import moment from "moment";

export const formatDisplayDate = (date) =>
  moment(date).format(process.env.VUE_APP_DISPLAY_DATE_FORMAT);

export const formatDate = (date) =>
  moment(date).format(process.env.VUE_APP_SERVER_DATE_FORMAT);
